import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getFnbDashboardData } from "./dashboard.thunk";

const init_state = {
  dashboardData: {
    stats: {},
    store_stats: [],
    terminal_stats: [],
  },
  loading: false,
  error: null,
};

export const fetchFnbDashboardData = createAsyncThunk(
  "fnb/dashboardData",
  getFnbDashboardData
);

const fnbDashboardSlice = createSlice({
  name: "fnb dashboard",
  initialState: init_state,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFnbDashboardData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFnbDashboardData.fulfilled, (state, action) => {
        state.dashboardData = action.payload;
        state.loading = false;
      })
      .addCase(fetchFnbDashboardData.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const {} = fnbDashboardSlice.actions;
export default fnbDashboardSlice.reducer;
